import { FC } from "react";
import { Environment } from "../app/App";
import './EnvironmentToggle.scss';

export type EnvironmentToggleProps = {
  environment: Environment,
  toggleEnvironment: Function,
};

const EnvironmentToggle: FC<EnvironmentToggleProps> = (props) => {

  return (
    <div className="env-toggle" onClick={props.toggleEnvironment as any}>on <u>{props.environment}</u>.</div>
  );
}

export default EnvironmentToggle;
